// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 820) return "static/chunks/820-6368731e16f062aa.js";
	if (chunkId === 176) return "static/chunks/176-8c7b4106289bcd96.js";
	if (chunkId === 973) return "static/chunks/973-6a67cfb0ed4bddbc.js";
	if (chunkId === 36) return "static/chunks/36-0b0f6bfa3afe29c0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"159":"6a3e91e12885d886","192":"5e7073de3a222e2f","203":"905c0583faa39c18","824":"fabcbcfb2e91511e","994":"0439ce099b91ef22"}[chunkId] + ".js";
};